import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className="footer">
      Site conçu par Sophie White
      <br />
      <a
        href="https://www.linkedin.com/in/sophie-e-white/"
        target="_blank"
        rel="noopener noreferrer"
      >
        LinkedIn   
      </a>
      <a
        href="https://github.com/SElizaWhi"
        target="_blank"
        rel="noopener noreferrer"
      >
        GitHub
      </a>
    </div>
  );
}

export default Footer
